// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Insider20 from './Insider20.tsx';
import Insider24 from './Insider24.tsx';

type InsiderProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Insider20,
    Insider24,
};

const Insider: FC<InsiderProps> = ({ variation, ...props }) => {
    const variationKey = `Insider${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Insider" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Insider;
